"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _lodash = require("lodash");

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _getColors = require("../../services/get-colors");

var _reactTextareaAutosize = _interopRequireDefault(require("react-textarea-autosize"));

var _inputText = _interopRequireDefault(require("./input-text.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InputText = /*#__PURE__*/function (_Component) {
  _inheritsLoose(InputText, _Component);

  function InputText(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      hasFocus: false
    });

    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = InputText.prototype;

  _proto.handleBlur = function handleBlur() {
    this.setState({
      hasFocus: false
    });
  };

  _proto.handleFocus = function handleFocus() {
    this.setState({
      hasFocus: true
    });
  };

  _proto.renderCounter = function renderCounter() {
    var _this$props = this.props,
        value = _this$props.value,
        maxLength = _this$props.maxLength;
    var left = maxLength - value.length;

    if (maxLength) {
      var _classNames;

      return /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])(_inputText["default"].counter, (_classNames = {}, _classNames[_inputText["default"].hasFocus] = this.state.hasFocus, _classNames)),
        style: left === 0 ? {
          color: (0, _getColors.getSecondaryColor)()
        } : null
      }, left);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        className = _this$props2.className,
        containerClassName = _this$props2.containerClassName,
        dir = _this$props2.dir,
        props = _objectWithoutPropertiesLoose(_this$props2, ["className", "containerClassName", "dir"]);

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_inputText["default"].inputWrapper, containerClassName),
      dir: dir
    }, /*#__PURE__*/_react["default"].createElement(_reactTextareaAutosize["default"], _extends({
      className: (0, _classnames["default"])(_inputText["default"].input, className),
      onFocus: this.handleFocus,
      onBlur: this.handleBlur
    }, (0, _lodash.omit)(props, ['dispatch']))), this.renderCounter());
  };

  return InputText;
}(_react.Component);

var _default = InputText;
exports["default"] = _default;